var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-taxonomy',_vm._b({on:{"input":_vm.onSelect},model:{value:(_vm.taxonomy),callback:function ($$v) {_vm.taxonomy=$$v},expression:"taxonomy"}},'select-taxonomy',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }